import React, { MouseEvent } from "react"
import { useState } from "react"
import { createRoot } from "react-dom/client"


function isDark(){
    return document.querySelector('html').dataset.bsTheme == 'dark'
}

function setTheme(dark:boolean){
    document.cookie = `theme=${dark ? 'dark' : 'light'}; path=/; max-age=31536000`;
    localStorage.setItem("theme", dark ? 'dark' : 'light')
    return document.querySelector('html').dataset.bsTheme = dark ? 'dark' : 'light'
}

function ThemeSelector(){
    const [dark, setDark] = useState(isDark())

    function toggleTheme(e:MouseEvent){
        e.preventDefault();
        setTimeout(() => {(document.querySelector('.navbar-toggler[aria-expanded="true"]') as HTMLButtonElement)?.click()}, 300);
        setTheme(!dark)
        setDark(!dark);
    }

    if(dark)
        return <a className="nav-link" onClick={toggleTheme} href="#"><i className='far fa-lightbulb'></i> Light Mode</a>
    return <a className="nav-link" onClick={toggleTheme} href="#"><i className='far fa-moon'></i> Dark Mode</a>    
}


function addCloseCollapse(){
    function close(){
        setTimeout(() => {(document.querySelector('.navbar-toggler[aria-expanded="true"]') as HTMLButtonElement)?.click()}, 700);
    }
    [...(document.querySelectorAll('.navbar-collapse .nav-item:not(.theme-selector) .nav-link') as any)].forEach(a => a.addEventListener('click', close))
}

function createApp(){
    addCloseCollapse();
    const root = createRoot(document.querySelector(".theme-selector"))
    root.render(<ThemeSelector />)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', createApp)
} else {
  createApp()
}